import { SkuFilterOptions } from "../helpers/skuFilters.helpers";
import { TImages } from "./vehicle.interface";

// eslint-disable-next-line no-shadow
export enum SkuStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export interface ISkuVariant {
  _id: string;
  color?: string;
  hasGps: boolean;
  price: number;
  status: SkuStatusEnum;
}

export interface ISku {
  _id: string;
  numericId: number;
  brand: string;
  model: string;
  brandName: string;
  brandAbbreviation: string;
  brandNumericId: number;
  modelName: string;
  modelNumericId: number;
  year: number;
  cc: number;
  version?: string;
  code: string;
  description: string;
  generalDescription?: string;
  minPrice?: number;
  images: TImages[];
  status: SkuStatusEnum;
  createdAt: string;
  updatedAt: string;
  variants?: ISkuVariant[];
}

export interface ISkuVariantWithSku extends ISkuVariant {
  sku: ISku;
}

export class TSku implements ISku {
  _id: string;
  numericId: number;
  brand: string;
  model: string;
  brandName: string;
  brandAbbreviation: string;
  brandNumericId: number;
  modelName: string;
  modelNumericId: number;
  year: number;
  cc: number;
  version?: string;
  code: string;
  description: string;
  generalDescription?: string;
  minPrice?: number;
  images: TImages[];
  status: SkuStatusEnum;
  createdAt: string;
  updatedAt: string;
  variants?: ISkuVariant[];

  constructor(data: ISku) {
    this._id = data._id;
    this.numericId = data.numericId;
    this.brand = data.brand;
    this.model = data.model;
    this.brandName = data.brandName;
    this.brandAbbreviation = data.brandAbbreviation;
    this.brandNumericId = data.brandNumericId;
    this.modelName = data.modelName;
    this.modelNumericId = data.modelNumericId;
    this.year = data.year;
    this.cc = data.cc;
    this.version = data.version;
    this.code = data.code;
    this.description = data.description;
    this.generalDescription = data.generalDescription;
    this.minPrice = data.minPrice ?? 0;
    this.images = data.images ?? [];
    this.status = data.status;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.variants = data.variants;
  }
}

export interface SkuFilters {
  brand?: string;
  model?: string;
  brandName?: string;
  modelName?: string;
  year?: number;
  cc?: number;
  minPrice?: number;
  maxPrice?: number;
  skuCode?: string;
  status?: SkuStatusEnum;
  sort?: string;
  searchText?: string;
  page?: number;
  limit?: number;
}

export interface ListSkus {
  skus: TSku[];
  filters: SkuFilterOptions;
  page: number;
  pages: number;
  count: number;
}
